import { useSuspenseQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { getJournalOptions } from '@/module/Journal';
import { JournalArticleInfluenceScoreView } from '@/module/Journal/JournalArticleInfluenceView';

export const Route = createFileRoute('/_auth/journal/_journal/$journalId/_layout/article-influence-score')({
  component: RouteComponent,
  staticData: {
    pageTitle: { id: 'journals.reputation.articleInfluenceScore.view' },
  },
});

function RouteComponent() {
  const { journalId } = Route.useParams();
  const { data: journal } = useSuspenseQuery(getJournalOptions(journalId));

  return (
    <JournalArticleInfluenceScoreView
      journalId={journalId}
      journalName={journal.title}
    />
  );
}
